import { IUTMParams } from "./store/user";

type flagOptions = "YES" | "NO" | "NOT SELECTED";
const defaultFagOptions = "NOT SELECTED";
export interface IRequestAQuote {
    idTour: string;
    firstName: string;
    lastName: string;
    age?: number;
    nationality: string;
    email: string;
    cellphone: string;
    datesOfTravel: {
        startDate: Date | null;
        endDate: Date | null;
    };
    numberPeople: string;
    numberPeopleComment?: number;
    numberRooms: string;
    numberRoomsComment?: number;
    activitiesToFocus: string[];
    preferredDestinations: string[];
    budgetPerPerson?: number;
    note: string;
    currency: string;
    alreadyBookAFlight: flagOptions;
    needAssistance: flagOptions;
    needTravelInsurance: flagOptions;
    marketingConsent: flagOptions;
    answers: {
        question: string;
        answer: string;
    }[];
    utm?: IUTMParams;
}

export const emptyRequestAQuote = (idTour: string): IRequestAQuote => {
    return {
        idTour,
        firstName: "",
        lastName: "",
        age: undefined,
        nationality: "",
        email: "",
        cellphone: "",
        datesOfTravel: {
            startDate: null,
            endDate: null,
        },
        numberPeople: "",
        numberRooms: "",
        currency: "",
        activitiesToFocus: [],
        preferredDestinations: [],
        budgetPerPerson: undefined,
        note: "",
        alreadyBookAFlight: defaultFagOptions,
        needAssistance: "NO",
        needTravelInsurance: defaultFagOptions,
        marketingConsent: defaultFagOptions,
        answers: [],
        utm: {
            utmSource: "",
            utmMedium: "",
            utmCampaign: "",
            utmTerm: "",
            utmContent: "",
        },
    };
};

export interface IRequestAQuoteFormMetadata {
    firstAndLastNameLabel: string;
    ageLabel: string;
    nationalityLabel: string;
    emailLabel: string;
    phoneNumberLabel: string;
    datesOfTravelLabel: string;
    howManyPeopleLabel: string;
    numberOfRoomsLabel: string;
    activitiesToFocusLabel: string;
    preferredDestinationsLabel: string;
    currencyLabel: string;
    budgetPerPersonLabel: string;
    alreadyBookAFlightLabel: string;
    needAssistanceLabel: string;
    specialNeedsLabel: string;
    needAssistanceToBookAFlightLabel: string;
    questions: string[];
    privacyConsentCaption: string;
    marketingConsentCaption: string;
}
